let appToasterMounted = false;
let queuedToastCounter = 1;
const queuedToasts = [];

export function isAppToasterMounted() {
  return appToasterMounted;
}

export function markAppToasterMounted() {
  appToasterMounted = true;
}

export function markAppToasterUnmounted() {
  appToasterMounted = false;
}

export function enqueueAppToast({ message, type, options }) {
  const id = options.id ?? `queued-app-toast-${queuedToastCounter++}`;
  queuedToasts.push({
    message,
    type,
    options: {
      ...options,
      id,
    },
  });
  return id;
}

export function flushAppToastQueue(dispatchToast) {
  const pendingToasts = queuedToasts.splice(0);
  return pendingToasts.map(dispatchToast);
}

export function resetAppToastMountStateForTests() {
  appToasterMounted = false;
  queuedToastCounter = 1;
  queuedToasts.splice(0);
}
